import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { updateFeedbackType, feedbackTypeQueryKeys } from '../api/feedbackTypes.api';
import type { UpdateFeedbackTypePayload } from '../types/feedbackType.types';

export function useUpdateFeedbackType(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: UpdateFeedbackTypePayload }) =>
      updateFeedbackType(id, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: feedbackTypeQueryKeys.all() });
      toast.success('Feedback type updated successfully');
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to update feedback type');
    },
  });
}
